import { Component, type ReactNode } from 'react'

interface Props {
  label: string
  children: ReactNode
}

interface State {
  err: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  override state: State = { err: null }

  static getDerivedStateFromError(err: Error): State {
    return { err }
  }

  override componentDidCatch(err: Error, info: { componentStack?: string | null }) {
    // Surface to the console so the user can copy/paste it back during debugging
    // eslint-disable-next-line no-console
    console.error(`[Bhāvan Atlas] ${this.props.label} crashed:`, err, info?.componentStack)
  }

  override render() {
    if (this.state.err) {
      return (
        <div className="w-full h-full p-4 bg-coral-50 border border-coral-200 rounded-md text-xs text-ink-300 overflow-auto">
          <div className="font-display text-sm text-coral-500 mb-2">
            The {this.props.label} could not render.
          </div>
          <div className="font-mono whitespace-pre-wrap leading-relaxed">
            {this.state.err.name}: {this.state.err.message}
            {this.state.err.stack && (
              <>
                {'\n\n'}{this.state.err.stack}
              </>
            )}
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
